import { render } from "./TheLoadingScreen.vue?vue&type=template&id=2a99b514"
const script = {}

import "./TheLoadingScreen.vue?vue&type=style&index=0&id=2a99b514&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__